import { StandardAccessRight } from "api/generated/model";

const ACCESS_RIGHTS = {
    ADMIN: StandardAccessRight.Admin,
    VIEW: StandardAccessRight.View,
    EDIT: StandardAccessRight.Edit,
};

const ACCESS_RIGHT_ORDERS: Record<StandardAccessRight, number> = {
    [ACCESS_RIGHTS.ADMIN]: 0,
    [ACCESS_RIGHTS.EDIT]: 1,
    [ACCESS_RIGHTS.VIEW]: 2,
};

export { ACCESS_RIGHTS, ACCESS_RIGHT_ORDERS };
